
















import CertCard from '@/components/card/CertCard.vue'
import Translation from '@/mixins/Translation'
import ListItem from '@/components/list/ListItem.vue'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import BttPopup from '@/components/popup/btt/BttPopup.vue'
import BankImg from '@/components/image/BankImg.vue'
import BankCodes from '@/components/BankCodes.vue'

@Component({
  components: {CertCard, BttPopup, ListItem, BankImg, BankCodes}
})
export default class BankCodeSelectionPopup extends Mixins(Translation) {
  @Prop({default: 'terms'}) translation: string
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: 'client', type: String}) type: string

  open: boolean = true
  loading: boolean = false

  @Watch('value', {immediate: true})
  __value(value) {
    this.open = value
  }

  @Watch('open', {immediate: true})
  __open(value) {
    this.$emit('input', value)
    if(!value) this.$emit('close')
  }

  close() {
    this.open = false
    this.$emit('close')
  }
  onClickCancel() {
    this.close()
  }

  onSelectCode(code) {
    this.$emit('code-selected', code)
    this.close()
  }
}
